// @flow

import * as React from "react";
import { ReactComponent as SocialSymbol } from "../../../assets/images/social-media-symbol.svg";
import Tile from "../molecules/Tile";

import API from "../../api/index";
import post from "../../utils/post";
import addACFData from "../../utils/addACFData";
import usePageFromStore from "../../hooks/usePageFromStore";
import getContentReferenceTileProps from "../../utils/getContentReferenceTileProps";
import { useLocation } from "react-router-dom";
import qs from "query-string";

const RelatedContent = (props: {
    title: string,
    categories?: Array<any>,
    tiles?: Array<any>,
    pageType?: string,
    useDynamicContent: boolean,
    endpoint?: string,
    postType?: string,
}): React.Node => {
    const location = useLocation();
    const queries = qs.parse(location.search);
    const classList = ["related-content"];

    const { page } = usePageFromStore();
    const [content, setContent] = React.useState([]);

    const random = () => {
        return 0.5 - Math.random();
    };

    if (props.pageType) {
        classList.push(`related-content--${props.pageType}`);
    }

    React.useEffect((): any => {
        let cancel = false;
        if (props.useDynamicContent) {
            const postType = post.getPostTypeAPIName(
                props.postType || page.post_type
            );

            if (!queries.preview) {
                if (props.categories) {
                    API.fetchPosts({
                        endpoint: props.endpoint,
                        postType: !props.endpoint ? postType : null,
                        perPage: 20,
                        filterKey: post.getCategoryForPostType(postType),
                        filterValue: props.categories
                            ? props.categories.join(",")
                            : "",
                        exclude: page.ID || page.id,
                        queryParms: {
                            orderby: "rand",
                        },
                    }).then(({ data }: any) => {
                        if (!cancel && data.length) {
                            setContent(data.sort(random));
                        }
                    });
                } else {
                    API.getCategoriesForPost(postType, page.ID).then(
                        (categories: number[]) => {
                            if (categories.length === 0) return;
                            API.fetchPosts({
                                endpoint: props.endpoint,
                                postType: !props.endpoint ? postType : null,
                                perPage: 20,
                                filterKey:
                                    post.getCategoryForPostType(postType),
                                filterValue: categories.join(","),
                                exclude: page.ID,
                                queryParms: {
                                    orderby: "rand",
                                },
                            }).then(({ data }: any) => {
                                if (!cancel && data.length) {
                                    setContent(data.sort(random));
                                }
                            });
                        }
                    );
                }
            }
        } else {
            setContent(props.tiles);
        }
        return () => {
            cancel = true;
        };
    }, [page]); // eslint-disable-line

    if (props.useDynamicContent && content && content.length === 0) {
        return null;
    }

    if (content && content.length > 0) {
        return (
            <div className={classList.join(" ")}>
                <div className="related-content__symbol-container">
                    <SocialSymbol />
                </div>
                <div className="related-content__container container">
                    <div className="related-content__top-content row">
                        <div className="col-xs-12">
                            <h1 className="related-content__heading">
                                {props.title}
                            </h1>
                        </div>
                    </div>
                    <div className="related-content__bottom-content row">
                        {content
                            .slice(0, 4)
                            .map((tile, tileIndex): React.Node => {
                                const referenceContent = tile.acf
                                    ? getContentReferenceTileProps(tile)
                                    : tile.tile_reference
                                    ? getContentReferenceTileProps(
                                          addACFData(tile.tile_reference)
                                      )
                                    : null;
                                const manualContent =
                                    tile.manual_content && tile.tile_content
                                        ? tile.tile_content
                                        : null;

                                if (manualContent || referenceContent) {
                                    return (
                                        <div
                                            key={tileIndex}
                                            className="col-xs-8 col-sm-3"
                                        >
                                            <Tile
                                                key={tileIndex}
                                                {...(manualContent ||
                                                    referenceContent)}
                                            />
                                        </div>
                                    );
                                } else {
                                    return null;
                                }
                            })}
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default RelatedContent;
